import { Capacitor } from "@capacitor/core";
import showPopupAdv from "./showPopupAdv";

export default function clickOccurredMaybeShowAdv() {
  const platform = Capacitor.getPlatform();

  if (platform === "android" || platform === "ios") {
    let number = Math.round(Math.random() * 7);

    console.log("adv chances", number);
    //20% chance of showing and adv
    if (number == 1) {
      showPopupAdv();
    }

    // showPopupAdv();
  }
}
